import { usePageTitle } from '@/hooks/use-page-title';
import { PlatformPageHeader } from '@/platform/components/platform-page-header';
import { PushDevicesCard } from '@/platform/features/notifications/push/push-devices-card';
import { ProfilePageShell } from '@/platform/features/profile/profile-shared';

export function ProfileDevicesPage() {
  usePageTitle('Geräte · Profil');

  return (
    <ProfilePageShell>
      <PlatformPageHeader
        title="Geräte"
        description="Push-Mitteilungen auf diesem und anderen Geräten."
      />
      <PushDevicesCard />
    </ProfilePageShell>
  );
}
